import { Modal } from 'react-bootstrap';
import React, { useContext } from 'react';
import { GoogleAnalyticsContext } from '../../../GoogleAnalytics';

const BulkConfirmationModal = ({
  show,
  onReset,
  onClose,
  hideHeader,
  hideCancel,
  onConfirm,
  children,
  header,
  buttonLabels,
  msg,
  disableApply,
  ...rest
}) => {
  const ga = useContext(GoogleAnalyticsContext);

  const closeModal = () => {
    if (ga.gaInitialized) {
      window?.gtag?.('event', 'Bulk Action Close', {
        event_category: 'Bulk Action',
      });
    }
    onClose();
  };

  return (
    <Modal centered data-bs-backdrop="static" show={show} onHide={() => null} {...rest}>
      <Modal.Header style={{ display: hideHeader ? 'none' : 'flex' }}>
        <Modal.Title>{header}</Modal.Title>
        <button id="close" type="button" class="btn-close" aria-label="Close" onClick={closeModal} />
      </Modal.Header>
      <Modal.Body>
        <>
          {children}
          {msg && (
            <div className="alert-danger px-3 py-1 w-100 text-center" style={{ borderRadius: '10px' }}>
              {msg}
            </div>
          )}
        </>
      </Modal.Body>
      <Modal.Footer
        class="d-flex flex-row py-3 px-3 gap-3 border-top bg-light justify-content-end align-items-center"
        style={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <button
          id="cancel"
          class="generic-btn bg-grey"
          onClick={onReset}
          style={{ display: hideCancel ? 'none' : 'flex', borderRadius: '10px' }}
        >
          {buttonLabels.label1}
        </button>
        <button
          id="confirm"
          class="generic-btn bg-yellow"
          disabled={disableApply}
          onClick={(event) => {
            onConfirm();
          }}
          style={{ borderRadius: '10px' }}
        >
          {buttonLabels.label2}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default BulkConfirmationModal;
